module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-2.ad98b990s.png";